if (window.innerWidth > 850) {
  const target = document.querySelector('.deferred-media__poster');

  function handleIntersection(entries) {
    entries.map((entry) => {
      if (entry.isIntersecting) {
        entry.target.click();
      }
    });
  }
  const observer = new IntersectionObserver(handleIntersection);

  observer.observe(target);
}

if (window.innerWidth < 850) {
  window.addEventListener('click', (e) => {
    if (e.target.matches('.thumbnail__video')) {
      document.querySelector('.product__media-item.is-active video').click();
      document.querySelector('.product__media-item.is-active video').play();
    }
  })
}